import React, { useState, useEffect } from "react";
import Logo from "../../../assets/images/logo.png";
import { Menu, X } from "lucide-react";
import VendorModal from "../../../features/LandingPage/vendor/VendorModal";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [vendorOpen, setVendorOpen] = useState(false);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      if (window.scrollY > lastScrollY && window.scrollY > 80) {
        setHidden(true);
      } else {
        setHidden(false);
      }
      lastScrollY = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header
        className={`
          fixed top-0 left-0 right-0 w-full z-50
          bg-[#6a0dad]
          px-6 md:px-[60px] py-[16px]
          flex items-center justify-between
          transition-transform duration-300
          ${hidden ? "-translate-y-full" : "translate-y-0"}
        `}
      >
        {/* LOGO */}
        <div className="flex items-center gap-2">
          <img src={Logo} alt="Saaflo Logo" className="w-auto h-14" />
        </div>

        {/* DESKTOP NAV */}
        <div className="items-center hidden gap-6 md:flex">
          <nav>
            <ul className="flex items-center gap-6 text-white text-[18px] font-medium">
              <li><a href="#home">Home</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#aboutus">About us</a></li>
              <li><a href="#contact">Contact Us</a></li>
            </ul>
          </nav>

          <button
            onClick={() => setVendorOpen(true)}
            className="bg-[#ffc933] text-[#6a0dad] px-6 py-2 rounded-md text-[16px] font-medium hover:bg-[#f8cf5e] transition"
          >
            Be a Vendor
          </button>
        </div>

        {/* MOBILE MENU BUTTON */}
        <button className="block md:hidden z-[1]" onClick={() => setOpen(!open)}>
          {open ? <X size={30} className="text-[#ffffff]" /> : <Menu size={30} className="text-[#ffffff]" />}
        </button>
      </header>

      {/* MOBILE MENU */}
      <div
        className={`
          md:hidden fixed left-0 w-full bg-white shadow-md z-[9999]
          transition-all duration-300 overflow-hidden
          ${open ? "top-[72px] max-h-[350px] opacity-100" : "top-[72px] max-h-0 opacity-0"}
        `}
      >
        <ul className="flex flex-col px-6 py-4 gap-5 text-[#8D8D90] text-[16px] font-medium">
          <li><a href="#home" onClick={() => setOpen(false)}>Home</a></li>
          <li><a href="#services" onClick={() => setOpen(false)}>Services</a></li>
          <li><a href="#aboutus" onClick={() => setOpen(false)}>About us</a></li>
          <li><a href="#contact" onClick={() => setOpen(false)}>Contact Us</a></li>

          <button
            onClick={() => { setVendorOpen(true); setOpen(false); }}
            className="bg-[#6a0dad] text-white px-6 py-3 rounded-md font-medium hover:bg-[#6a0dad] transition"
          >
            Be a Vendor
          </button>

        </ul>
      </div>
      <VendorModal open={vendorOpen} onClose={() => setVendorOpen(false)} />
    </>
    
  );
}
